<template>
    <CompanyBoxContent :title="$t('company.yourContacts') + ':'">
        <template #data>
            <div v-if="contacts.length === 0" class="text-center box">
                <span style="font-size: 16px;">{{ $t('company.noContacts') }}</span>
            </div>
            <div v-else class="table-responsive">
                <table class="table table-hover">
                    <thead class="table_head">
                        <tr>
                            <th>Jméno</th>
                            <th>Telefon</th>
                            <th>Email</th>
                            <th>Web</th>
                            <th class="text-end">Akce</th>
                        </tr>
                    </thead>
                    <tbody class="align-middle">
                        <tr v-for="contact in contacts" :key="contact.id">
                            <td class="align-middle">{{ contact.first_name }} {{ contact.last_name }}</td>
                            <td class="align-middle">
                                <span v-if="contact.phone">{{ contact.phone }}</span>
                            </td>
                            <td class="align-middle">
                                <span v-if="contact.email">{{ contact.email }}</span>
                            </td>
                            <td class="align-middle">
                                <a v-if="contact.web" :href="contact.web" target="_blank" style="color: black;">
                                    {{ contact.web }}
                                </a>
                            </td>
                            <td class="align-middle text-end">
                                <div class="d-flex justify-content-end">
                                    <button @click="editContact(contact.id)" class="btn btn-sm btn_edit me-2"
                                        data-bs-toggle="modal" data-bs-target="#editContactModal">
                                        <icon icon="Edit"></icon>
                                    </button>
                                    <button @click="deleteContact(contact.id)" class="btn btn-sm btn_delete">
                                        <icon icon="Bin"></icon>
                                    </button>
                                </div>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
            <div class="mt-3 text-center d-flex justify-content-center">
                <button class="btn btn_main d-flex align-items-center" data-bs-toggle="modal"
                    data-bs-target="#addContactModal">
                    <icon icon="Plus" class="me-2"></icon>
                    <span>{{ $t('general.addContact') }}</span>
                </button>
            </div>

            <!-- Modal for adding new contact -->
            <div class="modal fade" id="addContactModal" tabindex="-1" aria-labelledby="addContactModalLabel"
                aria-hidden="true">
                <div class="modal-dialog modal-dialog-centered">
                    <div class="modal-content modal_wrapper">
                        <div class="modal-header mx-auto border-0 pb-0">
                            <h3 class="modal-title title">{{ $t("general.addContact") }}</h3>
                        </div>
                        <div class="modal-body">
                            <div class="box contact_box p-4">
                                <div class="form-group mb-3">
                                    <div class="d-flex align-items-center">
                                        <label for="firstName" class="form-label me-3 label">
                                            {{ $t('general.writeFirstName') }}:<span class="text-danger">*</span>
                                        </label>
                                        <input type="text" id="firstName" class="form-control" v-model="firstName">
                                    </div>
                                </div>
                                <div class="form-group mb-3">
                                    <div class="d-flex align-items-center">
                                        <label for="lastName" class="form-label me-3 label">
                                            {{ $t('general.writeLastName') }}:
                                        </label>
                                        <input type="text" id="lastName" class="form-control" v-model="lastName">
                                    </div>
                                </div>
                                <div class="form-group mb-3">
                                    <div class="d-flex align-items-center">
                                        <label for="phone" class="form-label me-3 label">
                                            {{ $t('general.writePhone') }}:
                                        </label>
                                        <input type="text" id="phone" class="form-control" v-model="phone">
                                    </div>
                                </div>
                                <div class="form-group mb-3">
                                    <div class="d-flex align-items-center">
                                        <label for="email" class="form-label me-3 label">
                                            {{ $t('general.writeEmail') }}:
                                        </label>
                                        <input type="text" id="email" class="form-control" v-model="email">
                                    </div>
                                </div>
                                <div class="form-group">
                                    <div class="d-flex align-items-center">
                                        <label for="web" class="form-label me-3 label">
                                            {{ $t('general.writeWeb') }}:
                                        </label>
                                        <input type="text" id="web" class="form-control" v-model="web">
                                    </div>
                                </div>
                            </div>
                            <div class="modal-footer border-0 d-flex gap-2 justify-content-center mt-1 pb-0">
                                <button type="button" class="btn btn_secondary" data-bs-dismiss="modal"
                                    style="width: 130px;">
                                    <span>{{ $t('utils.close') }}</span>
                                </button>
                                <button class="btn btn_main d-flex align-items-center" data-bs-dismiss="modal"
                                    @click="addContact">
                                    <span>{{ $t('utils.submit') }}</span>
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <!-- Modal for editing contact -->
            <div class="modal fade" id="editContactModal" tabindex="-1" aria-labelledby="editContactModalLabel"
                aria-hidden="true">
                <div class="modal-dialog modal-dialog-centered">
                    <div class="modal-content modal_wrapper">
                        <div class="modal-header mx-auto border-0 pb-0">
                            <h3 class="modal-title title">{{ $t("general.editContact") }}</h3>
                        </div>
                        <div class="modal-body">
                            <div class="box contact_box p-4">
                                <div class="form-group mb-3">
                                    <div class="d-flex align-items-center">
                                        <label for="firstName" class="form-label me-3 label">
                                            {{ $t('general.writeFirstName') }}:<span class="text-danger">*</span>
                                        </label>
                                        <input type="text" id="firstName" class="form-control"
                                            v-model="editingFirstName">
                                    </div>
                                </div>
                                <div class="form-group mb-3">
                                    <div class="d-flex align-items-center">
                                        <label for="lastName" class="form-label me-3 label">
                                            {{ $t('general.writeLastName') }}:
                                        </label>
                                        <input type="text" id="lastName" class="form-control" v-model="editingLastName">
                                    </div>
                                </div>
                                <div class="form-group mb-3">
                                    <div class="d-flex align-items-center">
                                        <label for="phone" class="form-label me-3 label">
                                            {{ $t('general.writePhone') }}:
                                        </label>
                                        <input type="text" id="phone" class="form-control" v-model="editingPhone">
                                    </div>
                                </div>
                                <div class="form-group mb-3">
                                    <div class="d-flex align-items-center">
                                        <label for="email" class="form-label me-3 label">
                                            {{ $t('general.writeEmail') }}:
                                        </label>
                                        <input type="text" id="email" class="form-control" v-model="editingEmail">
                                    </div>
                                </div>
                                <div class="form-group">
                                    <div class="d-flex align-items-center">
                                        <label for="web" class="form-label me-3 label">
                                            {{ $t('general.writeWeb') }}:
                                        </label>
                                        <input type="text" id="web" class="form-control" v-model="editingWeb">
                                    </div>
                                </div>
                            </div>
                            <div class="modal-footer border-0 d-flex gap-2 justify-content-center mt-1 pb-0">
                                <button type="button" class="btn btn_secondary" data-bs-dismiss="modal"
                                    style="width: 130px;">
                                    <span>{{ $t('utils.close') }}</span>
                                </button>
                                <button class="btn btn_main d-flex align-items-center" data-bs-dismiss="modal"
                                    @click="saveEditedContact">
                                    <span>{{ $t('utils.submit') }}</span>
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </template>
    </CompanyBoxContent>
</template>

<script>
import CompanyBoxContent from "@/components/CompanyBoxContent.vue";
import UserAvatar from "@/components/CompanyDetail/UserAvatar.vue";

export default {
    props: {
        company: {
            type: Object,
            required: true
        },
        contacts: {
            type: Object,
            required: true
        },
    },
    components: {
        CompanyBoxContent,
        UserAvatar
    },
    data() {
        return {
            firstName: "",
            lastName: "",
            phone: "",
            email: "",
            web: "",
            editingContact: false,
            editingContactId: null,
            editingFirstName: "",
            editingLastName: "",
            editingPhone: "",
            editingEmail: "",
            editingWeb: "",
        };
    },
    methods: {
        addContact() {
            if (!this.firstName.trim() && !this.lastName.trim() && !this.phone.trim() && !this.email.trim() && !this.web.trim()) {
                return; // Prevent adding empty contacts
            }
            const formData = {
                firstName: this.firstName,
                lastName: this.lastName,
                phone: this.phone,
                email: this.email,
                web: this.web
            };

            this.$store.getters.api.post(`/company/${this.$route.params.slug}/company_contact/add`, formData)
                .then(response => {
                    // Refresh company data after adding the contact
                    this.$emit('reload');
                    this.firstName = "";
                    this.lastName = "";
                    this.phone = "";
                    this.email = "";
                    this.web = "";
                })
        },
        deleteContact(contactID) {
            this.$store.getters.api.delete(`/company/${this.$route.params.slug}/company_contact/${contactID}/delete`)
                .then(response => {
                    this.$emit('reload');
                })
        },
        editContact(contactID) {
            this.editingContact = true;
            this.editingContactId = contactID;

            const contact = this.contacts.find(contact => contact.id === contactID);
            this.editingFirstName = contact ? contact.first_name : "";
            this.editingLastName = contact ? contact.last_name : "";
            this.editingPhone = contact ? contact.phone : "";
            this.editingEmail = contact ? contact.email : "";
            this.editingWeb = contact ? contact.web : "";
        },
        saveEditedContact() {
            const formData = {
                firstName: this.editingFirstName,
                lastName: this.editingLastName,
                phone: this.editingPhone,
                email: this.editingEmail,
                web: this.editingWeb,
            };

            this.$store.getters.api.put(`/company/${this.$route.params.slug}/company_contact/${this.editingContactId}/edit`, formData)
                .then(response => {
                    this.$emit("reload");
                    this.cancelEdit();
                })
        },
        cancelEdit() {
            this.editingContact = false;
            this.editingContactId = null;
            this.editingFirstName = "";
            this.editingLastName = "";
            this.editingPhone = "";
            this.editingEmail = "";
            this.editingWeb = "";
        },
    }
};
</script>

<style scoped lang="scss">
@import "@/scss/abstracts/variables";
@import "@/scss/base/typography.scss";

.label {
    width: 150px;
}

.contact_box {
    min-height: 100px;
    max-height: auto;
    overflow-y: auto;
    border-radius: $radius-lg;
}

.modal_wrapper {
    border-radius: $radius-xl;

    label {
        font-weight: 700;
    }
}

.btn_edit {
    color: $dark-purple;
    border: none;
    font-weight: 600;

    svg {
        stroke: $dark-purple;
        width: 30px;
        height: 30px;
    }
}

.btn_delete {
    color: $dark-purple;
    border: none;
    font-weight: 600;

    svg {
        stroke: $dark-purple;
        width: 30px;
        height: 30px;
    }
}

@media screen and (max-width: 1700px) {
    .full_width {
        width: 100%;
    }
}
</style>